
import { defineComponent, ref } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { dispatch } = useStore()
    const showImage = ref("")
    dispatch("complete/classify", [
      require("@/assets/img-direct.png"),
      require("@/assets/img-direct.png"),
      require("@/assets/img-message.png"),
      require("@/assets/img-direct.png"),
    ]).then((data) => {
      showImage.value = data
    })
    return {
      showImage,
    }
  },
})
